import { Env } from '../../../../core/env';
import { isSoloare } from '../../../../core/models/js_env';
import { RootContainer } from '../../../../core/root_container';
import { applyCarouselStyle } from '../../../../core/views/common/carousel_util';
import { CategoryLlAndLJsEnv } from '../../models/category_ll_and_l_js_env';
import { RrBodyLl1, RrBodyLl2, RrBodyL1, RrBodyL2, RrBodyL3 } from './rr_body';
import { loadingDisplayNone, removeLoading } from '../../../../core/util/dom_util';

export class CategoryLlAndLContainer extends RootContainer<CategoryLlAndLJsEnv> {
  constructor(model: CategoryLlAndLJsEnv) {
    super();

    if (isSoloare(Env.SITE_TYPE)) {
      if (model.isLlCategory) {
        this.mount(RrBodyLl1, model.rrAreaProfileLl1.placementName);

      } else {
        this.mount(RrBodyL1, model.rrAreaProfileL1.placementName);
      }

      // 初回描画
      this.update(model);

      const placementNameList = model.isLlCategory ? [model.rrAreaProfileLl1.placementName] : [model.rrAreaProfileL1.placementName]

      const carouselIdList = placementNameList.map(placementName => placementName + "-carousel")
      applyCarouselStyle(carouselIdList)
    } else {
      if (model.isFromExternalSite) {
        // 外部流入の場合はタイマーを解除し、商品0件の場合はローディングモジュールを非表示とする
        clearTimeout(model.rrAreaProfileL1.timeoutId);
        if (model.rrAreaProfileL1.rrAreaItems.length === 0) {
          loadingDisplayNone(model.rrAreaProfileL1.placementName);
        }
      }

      if (model.isLlCategory) {
        this.mount(RrBodyLl1, model.rrAreaProfileLl1.placementName);
        this.mount(RrBodyLl2, model.rrAreaProfileLl2.placementName);

      } else {
        this.mount(RrBodyL1, model.rrAreaProfileL1.placementName);
        this.mount(RrBodyL2, model.rrAreaProfileL2.placementName);
        this.mount(RrBodyL3, model.rrAreaProfileL3.placementName);
      }

      // 初回描画
      this.update(model);

      if (model.isFromExternalSite) {
        // 外部流入の場合ローディングクラスを削除する
        removeLoading(model.rrAreaProfileL1.placementName);
      }

      const placementNameList = model.isLlCategory ? [model.rrAreaProfileLl1.placementName, model.rrAreaProfileLl2.placementName]
        : [model.rrAreaProfileL1.placementName, model.rrAreaProfileL2.placementName, model.rrAreaProfileL3.placementName]

      const carouselIdList = placementNameList.map(placementName => placementName + "-carousel")
      applyCarouselStyle(carouselIdList)
    }
  }
}
